import { Link } from 'react-router-dom'

export default function Footer() {
  const year = new Date().getFullYear()
  return (
    <footer className="border-t border-slate-border mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-sepia">
        <span>© {year} Heirloom-homes</span>
        <nav className="flex items-center gap-5">
          <Link to="/privacy" className="hover:text-gold transition-colors no-underline">Privacy</Link>
          <Link to="/terms" className="hover:text-gold transition-colors no-underline">Terms</Link>
          <a href="mailto:support@heirloom-homes.com" className="hover:text-gold transition-colors no-underline">support@heirloom-homes.com</a>
        </nav>
      </div>
    </footer>
  )
}
